import translations from '@nike/gameday-translations/web';

import countries from './countriesSAP';

export function accLanguageTranslations(name, number) {
  const { en } = translations;
  return !en[`accountDropdown.accountId.${number}`] ? `${name}` : `${en[`accountDropdown.accountId.${number}`]}`;
}

export function deptLanguageTranslations(name, number) {
  const { en } = translations;
  return !en[`shop.deptSelect.deptName.${number}`] ? `${name}` : `${en[`shop.deptSelect.deptName.${number}`]}`;
}

export function getUserRole() {
  const userData = JSON.parse(localStorage.getItem('user'));

  return userData?.role === 'GAMEDAY_SUPER_USER';
}

export const getChinaProvinceFromCode = (locale, code) => {
  if (!code) return '';

  const chinaProvinces = countries.find(country => country.code2 === 'CN').states;
  const isChinaLocale = locale === 'cn_cn';

  const provinceMatch = chinaProvinces.find(province => province.code === code);

  return provinceMatch ? provinceMatch[isChinaLocale ? 'nameCN' : 'name'] : code;
};

export const getCNCityTranslationAccessor = locale => {
  switch (locale) {
    case 'cn_cn':
      return 'cityName';
    case 'tc_cn':
      return 'cityNameTraditional';
    default:
      return 'normalizedCityName';
  }
};

export const getCNProvinceTranslationAccessor = locale => {
  switch (locale) {
    case 'cn_cn':
      return 'nameCN';
    case 'tc_cn':
      return 'nameCNTraditional';
    default:
      return 'name';
  }
};

export const getCNTranslationAccessor = locale => {
  switch (locale) {
    case 'cn_cn':
      return 'nameSimplifiedChinese';
    case 'tc_cn':
      return 'nameTraditionalChinese';
    default:
      return 'name';
  }
};
